export function box(x0, x1, z0, z1) {
  return [[x0, z0], [x1, z0], [x1, z1], [x0, z1]];
}
